/* eslint-disable sonarjs/deprecation -- Tényleg? */

import Alert from '../Alert/Alert'
import Modal, { closeActualModal } from '../Modal/Modal'

import type { TState } from '../definitions'

interface IProps {
  readonly type?: TState
  readonly body?: HTMLElement
  readonly title?: string
  readonly buttonText?: string
  /**
   * @deprecated Már csak legacy okok miatt van megtartva, használd helyette a type-ot!
   */
  readonly isConfirm?: boolean
}

/**
 * Megerősítő ablak.
 * @param props - JSX props {@link IProps}.
 */
export default function ConfirmModal (props: IProps): Promise<boolean> {
  return new Promise((resolve) => {
    /**
     * Létrehoz egy új click függvényt a megfelelő paraméterrel.
     * @param isConfirmed - Megerősítve vagy sem.
     */
    function onClickFactory (isConfirmed: boolean): TVoidCallback {
      return function onClick (): void {
        closeActualModal()
        resolve(isConfirmed)
      }
    }

    const header: HTMLElement = (
      <Alert className="m-0" type={ props.type ?? 'light' }>
        <div dangerouslySetInnerHTML={ { __html: props.title ?? 'Biztosan törölni szeretnéd?' } } />
      </Alert>
    )

    /* eslint-disable custom/no-nested-ternary -- Legacy. */
    const cancelClassName: readonly string[] = [
      'btn',
      props.isConfirm
        ? 'btn-danger'
        : props.type
          ? 'btn-light'
          : 'btn-primary'
    ]

    const confirmClassName: readonly string[] = [
      'btn',
      props.isConfirm
        ? 'btn-success'
        : props.type
          ? `btn-${ props.type }`
          : 'btn-danger'
    ]
    /* eslint-enable custom/no-nested-ternary */

    Modal({
      header,
      body: props.body ?? null,
      zIndex: 5000,
      footer: (
        <div className={ [ 'modal-footer', 'col-sm-12' ] }>
          <button
            className={ cancelClassName }
            type="button"
            onClick={ onClickFactory(false) }
          >
            Mégsem
          </button>

          <button
            className={ confirmClassName }
            type="button"
            onClick={ onClickFactory(true) }
          >
            { props.buttonText ?? (props.isConfirm ? 'Mehet' : 'Törlés') }
          </button>
        </div>
      )
    })
  })
}
